import { connect } from 'react-redux';
import { getDuperbrowseStreamParent, getCurrentItem } from '../../Duperbrowse/redux/selectors';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
const mapStateToProps = (state)=>{
    const currentItem = getCurrentItem(state);
    const isOwner = currentItem ? getIsCurrentUserAuthorOf(state, currentItem) : false;
    return {
        parent: getDuperbrowseStreamParent(state),
        currentItem,
        isOwner
    };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
